import type { JSX } from "react";

import {
  cva,
  cx,
  type RecipeVariantProps,
} from "@mobsuccess-devops/styled-system/css";
import { hstack } from "@mobsuccess-devops/styled-system/patterns";

import { Dot } from "./Dot";
import type { styles as dotStyles } from "./styles";

type EllipsisProps = RecipeVariantProps<typeof styles> &
  RecipeVariantProps<typeof dotStyles> & { className?: string } & object;

export function Ellipsis({
  size,
  color,
  shown,
  className,
}: EllipsisProps): JSX.Element {
  const classes = styles({ size, shown });
  return (
    <div className={cx(classes, className)} role="progressbar">
      <Dot size={size} color={color} role="none" />
      <Dot size={size} color={color} delay={1} role="none" />
      <Dot size={size} color={color} delay={2} role="none" />
    </div>
  );
}

const styles = cva({
  base: hstack.raw(),
  variants: {
    size: {
      sm: {
        gap: "2px",
      },
      md: {
        gap: "4px",
      },
      lg: {
        gap: "6px",
      },
    },

    shown: {
      false: {
        display: "none",
      },
    },
  },
  defaultVariants: {
    size: "md",
    shown: true,
  },
});
